import * as Sentry from '@sentry/react'

import type { Router } from '@/main'
import type { RootSearch } from '@/routes/__root'
import { getLocaleFromPath } from '@/utils/base-path-params'
import { getPlatform } from '@/utils/get-platform'

const DSN = 'https://020e1fd306605cac8079e5969773291f@o514642.ingest.us.sentry.io/4510227376439296'

export function initSentry(router: Router) {
  Sentry.init({
    dsn: DSN,
    enabled: import.meta.env.MODE === 'production',
    ignoreErrors: [
      'Failed to fetch',
      'Failed to send .* event, TypeError: .*',
      'TypeError: Failed to fetch',
      'Load failed',
      'ConnectionProblemException',
      'GAID not found',
      'Error loading gtag',
    ],
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.captureConsoleIntegration({
        levels: ['error'],
      }),
      Sentry.replayCanvasIntegration(),
      Sentry.replayIntegration({
        block: ['kompis-keyboard'],
        blockAllMedia: false,
        maskAllInputs: true,
        maskAllText: false,
      }),
      Sentry.tanstackRouterBrowserTracingIntegration(router),
    ],
    release: import.meta.env.VITE_APP_VERSION,
    // Session Replay
    replaysOnErrorSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    // Tracing
    tracesSampleRate: 0.1,
  })

  setTags(router.latestLocation.search)
}

function setTags(search: RootSearch) {
  Sentry.setTag('betraktaVersion', __BETRAKTA_VERSION__)
  Sentry.setTag('motorVersion', __CORE_VERSION__)
  Sentry.setTag('kompisVersion', __KOMPIS_VERSION__)
  Sentry.setTag('platform', getPlatform(search))
  Sentry.setTag('locale', getLocaleFromPath())
  Sentry.setTag('storeId', search.storeId)
}
